import { useCallback, useState } from "react";

import FlexItem from "@gx/dls/containers/FlexItem";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";

import CreateSourceModalWrapper from "@/pages/sources/components/create/components/CreateSourceModalWrapper";
import CreateSourceSelectorBody from "@/pages/sources/components/create/select/CreateSourceSelectorBody";
import CreateSourceSelectorHeader from "@/pages/sources/components/create/select/CreateSourceSelectorHeader";
import {
  CreateSourceSelectorProps,
  CreateSourceStep,
} from "@/pages/sources/components/create/types";

interface CreateSourceSelectorState {
  search: string;
}

const CreateSourceSelector = ({ onClose, onSelect }: CreateSourceSelectorProps) => {
  const [state, setState] = useState<CreateSourceSelectorState>({ search: "" });

  const handleSearchChange = useCallback((search: string) => {
    setState((prev) => ({ ...prev, search }));
  }, []);

  return (
    <CreateSourceModalWrapper step={CreateSourceStep.SELECT}>
      <CreateSourceSelectorHeader
        search={state.search}
        onSearchChange={handleSearchChange}
        onClose={onClose}
      />
      <FlexItem>
        <HorizontalDivider />
      </FlexItem>
      <CreateSourceSelectorBody search={state.search} onSelect={onSelect} />
    </CreateSourceModalWrapper>
  );
};

export default CreateSourceSelector;
